import React from 'react';
import { connect } from 'react-redux';
import { fetchEventDetails } from '../../actions/event';
import { fetchResponses } from '../../actions/responses';
import './SentimentByRating.css';
import Event from '../../models/Event';
import ErrorAndRefresh from '../shared/ErrorAndRefresh';
import { handleError } from '../../util/Errors';
import { SentimentByRatingChart } from '../charts/SentimentByRatingChart';
import Sentiment from '../../models/Sentiment';

class SentimentByRating extends React.Component {

  componentDidUpdate (prevProps) {
    const { sentimentByRatingError } = this.props;
    handleError(sentimentByRatingError, prevProps.sentimentByRatingError);
  }

  loadStats = () => {
    const { fetchEventDetails, fetchResponses, event } = this.props;
    fetchEventDetails(Event.getId(event));
    fetchResponses(Event.getId(event));
  };

  render () {
    const { sentimentByRating, sentimentByRatingError } = this.props;

    if (sentimentByRatingError || !sentimentByRating) {
      return (
        <div className="sentiment-by-rating">
          <ErrorAndRefresh
            error="Failed to load Sentiment By Rating Data"
            onRefresh={ this.loadStats }
          />
        </div>
      );
    }

    const data = [
      {
        // Negative Sentiments
        data: sentimentByRating.map(s => parseFloat(Sentiment.getNegativePercent(s).toFixed(2)))
          .map(y => ({
            y: y,
            className: 'page-break-avoid'
          })),

        // Start at X 1
        pointStart: 1,

        color: '#FF0000'
      },
      {
        // Neutral Sentiments
        data: sentimentByRating.map(s => parseFloat(Sentiment.getNeutralPercent(s).toFixed(2)))
          .map(y => ({
            y: y,
            className: 'page-break-avoid'
          })),

        // Start at X 1
        pointStart: 1,

        color: '#FFFF00'
      },
      {
        // Positive Sentiments
        data: sentimentByRating.map(s => parseFloat(Sentiment.getPositivePercent(s).toFixed(2)))
          .map(y => ({
            y: y,
            className: 'page-break-avoid'
          })),

        // Start at X 1
        pointStart: 1,

        color: '#008000'
      }
    ];

    return (
      <div>
        <div className="row no-gutters sentiment-by-rating print-card-header">
          <SentimentByRatingChart
            chartId="Sentiment By Rating"
            data={ data }
            customChartContainerClass="sentiment-chart-container"
            customChartClass="sentiment-chart"
            forceReflowBecauseOfBug={ true }
          />
        </div>
      </div>
    );
  }

}

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user,
    sentimentByRatingError: state.event.sentimentByRatingError
  };
};

export default connect(mapStateToProps, {
  fetchEventDetails,
  fetchResponses
})(SentimentByRating);

